export default state => {
  return state.shappy.status
}



// WEBPACK FOOTER //
// ./src/store/modules/shappy/getters/getShopStatus.js